import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '../../assets/icons/delete.svg';
import ViewMoreIcon from '../../assets/icons/view-more.svg';
import ScreenLoader from '../../components/common/ScreenLoader';
import SearchField from '../../components/common/Search';
import DeletePermissionsModal from '../../components/common/modals/delete';
import { teachersTableHeader } from '../../constants/appConstants';
import { setTeachers } from '../../redux/slice/appSlice';
import { AuthenticatedGETRequest, gotoLocation } from '../../utils';

const Teachers = ({ createNotification }) => {
    const { teachers } = useSelector((state) => state.appReducer);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [searchedRows, setSearchedRows] = useState(null);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    useEffect(() => {
        setLoading(true);
        const fetchTeachers = async () => {
            try {
                const { data } = await AuthenticatedGETRequest('teachers');
                setLoading(false);
                dispatch(setTeachers(data));
                setSearchedRows(data);
            } catch (error) {
                createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
            }
        };
        fetchTeachers();
        // eslint-disable-next-line
    }, [createNotification]);

    return loading ? (
        <ScreenLoader />
    ) : (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            <div className='flex justifyCenter alignCenter w-100'>
                <h2>
                    اساتذہ کی مجموعی تعداد :
                    <span
                        style={{
                            fontFamily: 'CircularStd',
                            fontSize: 26,
                            marginRight: 8,
                            color: '#2196f3',
                        }}
                    >
                        {searchedRows ? searchedRows.length : 0}
                    </span>
                </h2>
            </div>

            <SearchField
                label={`شناختی کارڈ اور موبائل نمبر سے ریکارڈ تلاش کریں `}
                data={searchedRows}
                list={teachers}
                setSearchedRows={setSearchedRows}
            />
            {searchedRows && searchedRows.length > 0 ? (
                <div className='flex column w-100'>
                    <div className='flex justifyStart alignCenter table_header'>
                        {teachersTableHeader.map((header, index) => (
                            <h3
                                key={index + 1}
                                className='table_header_element'
                                style={{
                                    width:
                                        index === 0
                                            ? 60
                                            : index === 1
                                            ? 140
                                            : index === 2
                                            ? 100
                                            : index === 3
                                            ? 120
                                            : index === 4
                                            ? 140
                                            : index === 5
                                            ? 120
                                            : index === 6
                                            ? 120
                                            : 120,
                                    textAlign:
                                        index === 0 || index === 1 || index === 2
                                            ? 'right'
                                            : 'center',
                                }}
                            >
                                {header}
                            </h3>
                        ))}
                    </div>

                    <div className='flex column justifyStart alignCenter tabe_data_row'>
                        {searchedRows.map((user, index) => (
                            <div
                                className='flex justifyStart alignCenter table_row'
                                key={index + 1}
                            >
                                <h4 style={{ width: 60, textAlign: 'right' }}>{index + 1}</h4>
                                <div
                                    className='flex justifyStart alignCenter'
                                    style={{ width: 140 }}
                                >
                                    <h3>{user.name}</h3>
                                </div>
                                <h3 style={{ width: 100, textAlign: 'right' }}>
                                    {user.father_name}
                                </h3>
                                <h3 style={{ width: 120, fontFamily: 'CircularStd', fontSize: 14 }}>
                                    {user.primary_phone_number}
                                </h3>
                                <h3 style={{ width: 140, fontFamily: 'CircularStd', fontSize: 14 }}>
                                    {user.cnic}
                                </h3>
                                <div
                                    className='flex justifyCenter alignCenter'
                                    onClick={() =>
                                        gotoLocation(`dashboard/teachers/detail?id=${user.id}`)
                                    }
                                    style={{ width: 120 }}
                                >
                                    <img
                                        src={ViewMoreIcon}
                                        alt='forward_icon'
                                        height={22}
                                        width={22}
                                    />
                                    <h4 style={{ marginRight: 8 }}>تفصیلات دیکھیں</h4>
                                </div>
                                <div
                                    className='flex justifyCenter alignCenter'
                                    onClick={() => {
                                        setDeleteId(user.id);
                                        setDeleteModal(true);
                                    }}
                                    style={{ width: 120 }}
                                >
                                    <img
                                        src={DeleteIcon}
                                        alt='delete_icon'
                                        height={32}
                                        width={32}
                                    />
                                    <h4 style={{ marginRight: 8 }}>حذف کریں</h4>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className='flex justifyCenter alignCenter w-100'>
                    <h1 style={{ marginTop: 56, color: '#e91e63', fontWeight: 900 }}>
                        {searchedRows && searchedRows.length > 0
                            ? 'معذرت، اساتذہ کا کوئی ڈیٹا موجود نہیں ہے۔'
                            : ' اساتذہ کی طرف سے کوئی درخواست موصول نہیں ہوئی ہے۔'}
                    </h1>
                </div>
            )}

            <DeletePermissionsModal
                label='استاد صاحب کا ریکارڈ حذف کریں'
                description='کیا آپ استاد صاحب کے ریکارڈ کو مستقل طور پر حذف کرنے کا یقین رکھتے ہیں؟'
                btnText='حذف کریں'
                open={deleteModal}
                id={deleteId}
                screen='teachers'
                onError={(error) => createNotification('error-toast', error)}
                onClose={() => setDeleteModal(false)}
            />
        </div>
    );
};

export default Teachers;
